"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utils_1 = require("../Utils");
/**
 * Helper functions for selecting things in a grid that acts like a tree.
 */
var TreeGridSelectionUtils = /** @class */ (function () {
    function TreeGridSelectionUtils() {
    }
    /**
     * This is a iterator that traverses the ranges in the selection and calls the callback for each row
     * @param selectionData - the selection ranges to iterate
     * @param callback - the function to call for each row index in the selection
     */
    TreeGridSelectionUtils.forEachRowIndexInSelection = function (selectionData, callback) {
        if (!!selectionData && !!selectionData.rowRanges) {
            selectionData.rowRanges.forEach(function (range) {
                var normalizedRange = TreeGridSelectionUtils.getNormalizedRange(range);
                for (var i = normalizedRange.begin; i <= normalizedRange.end; i++) {
                    callback(i);
                }
            });
        }
    };
    /** @returns a new range whose begin row value is guaranteed to be <= end row value */
    TreeGridSelectionUtils.getNormalizedRange = function (range) {
        return { begin: Math.min(range.begin, range.end),
            end: Math.max(range.begin, range.end) };
    };
    /**
     * Modifies the given ranges to create a split so that there are no ranges spanning across the requested split area.
     * This is used to fix up selection indexes when a parent node is expanded/collapsed.
     * @returns an array of ranges that were removed due to the split
     * @param ranges - the ranges to split
     * @param splitBegin - the row just above where the split happens
     * @param splitEnd - if this is greater than splitBegin, the rows between begin and end will be extracted and returned from the method.
     * @param gapRows - ranges below splitEnd will be increased by this value
     */
    TreeGridSelectionUtils.splitRanges = function (ranges, splitBegin, splitEnd, gapRows) {
        Utils_1.assert(splitBegin <= splitEnd, 'splitEnd must be >= splitBegin');
        var extractedRanges = [];
        // iterate backwards so ranges can be removed if necessary
        for (var i = ranges.length - 1; i >= 0; i--) {
            var rangeToUpdate = ranges[i];
            var normalizedRange = TreeGridSelectionUtils.getNormalizedRange(rangeToUpdate);
            // if range is completely above the split, do nothing
            if (normalizedRange.end <= splitBegin) {
                continue;
            }
            // if range is completely below the split, apply the gapRows delta
            if (normalizedRange.begin > splitEnd) {
                rangeToUpdate.begin += gapRows;
                rangeToUpdate.end += gapRows;
                continue;
            }
            // remove this range since will be replaced by the new ranges created below.
            ranges.splice(i, 1);
            // split off any part of the range that's above or at splitBegin
            if (normalizedRange.begin <= splitBegin) {
                ranges.push({ begin: normalizedRange.begin, end: splitBegin });
            }
            // remove any part of the range that falls within the split, and add it to extracted ranges
            if (splitBegin < splitEnd && (normalizedRange.begin <= splitEnd && splitBegin + 1 <= normalizedRange.end)) {
                extractedRanges.push({ begin: Math.max(splitBegin + 1, normalizedRange.begin), end: Math.min(splitEnd, normalizedRange.end) });
            }
            // split off any part of the range that's below splitEnd, and also apply gapRows delta
            if (normalizedRange.end > splitEnd) {
                ranges.push({ begin: splitEnd + 1 + gapRows, end: normalizedRange.end + gapRows });
            }
        }
        return extractedRanges;
    };
    /**
     * Finds selected hidden rows from within the specified domain range and makes them visible by
     * removing them from the hiddenDomainSelectionRanges and adding them to the visibleGridSelectionRanges.
     * @param hiddenDomainSelectionRanges - all hidden selected ranges (range values are domain indexes)
     * @param visibleGridSelectionRanges - all visible selected ranges (range values are grid indexes)
     * @param gridIndexOffset - the location where newly-visible selections will be inserted
     * @param domainRangeToUnhide - the domain range we constrain our search to when finding hidden selections
     * @return true if the selection has changed
     */
    TreeGridSelectionUtils.unhideDomainSelections = function (hiddenDomainRanges, visibleGridRanges, gridIndexOffset, domainRangeToUnhide) {
        var normalizedDomainRangeToUnhide = TreeGridSelectionUtils.getNormalizedRange(domainRangeToUnhide);
        if (normalizedDomainRangeToUnhide.begin > normalizedDomainRangeToUnhide.end) {
            return false; // there is nothing to unhide
        }
        // iterate backwards so we can remove items from hiddenDomainRanges as we go.
        var selectionIsChanged = false;
        for (var i = hiddenDomainRanges.length - 1; i >= 0; i--) {
            var selectedDomainRange = TreeGridSelectionUtils.getNormalizedRange(hiddenDomainRanges[i]);
            // if the selection is within the area we're unhiding, move it from hidden to visible, and convert it from domain index to grid index
            if (selectedDomainRange.begin >= normalizedDomainRangeToUnhide.begin &&
                selectedDomainRange.end <= normalizedDomainRangeToUnhide.end) {
                var beginOffset = selectedDomainRange.begin - normalizedDomainRangeToUnhide.begin;
                var numItems = selectedDomainRange.end - selectedDomainRange.begin;
                visibleGridRanges.push({ begin: gridIndexOffset + beginOffset, end: gridIndexOffset + beginOffset + numItems });
                hiddenDomainRanges.splice(i, 1);
                selectionIsChanged = true;
            }
        }
        return selectionIsChanged;
    };
    return TreeGridSelectionUtils;
}());
exports.TreeGridSelectionUtils = TreeGridSelectionUtils;
//# sourceMappingURL=TreeGridSelectionUtils.js.map